// extracted by mini-css-extract-plugin
module.exports = {"Container":"SettingsDevices_Container___Yjvt","Table":"SettingsDevices_Table__rLmbR","Action":"SettingsDevices_Action__upkn5","Delete":"SettingsDevices_Delete__UvOJj"};